import { styled } from '@mui/material';

export const ScreenWrapper = styled('div')(() => ({
  width: '100%',
  backgroundColor: '#828282',
  padding: 20,
}));
